export const getWidth = (columnWidth, tableWidth) => {
  return `${(columnWidth * 100) / tableWidth}%`
}

export const getFilterValue = (filterOptions, filterName) => {
  // eslint recommends hasOwn but that doesn't work in Chrome.
  // eslint-disable-next-line no-prototype-builtins
  return (filterOptions.hasOwnProperty(filterName) && filterOptions[filterName].filter) ? filterOptions[filterName].filter : ''
}
